import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useSubscription } from '../../hooks/useSubscription'
import { toast } from 'react-toastify'
import AuthModal from '../AuthModal'
import { useTranslation } from 'react-i18next'
import './style.css'

const CustomBanner = (props) => {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();
    const { hasActiveSubscription, isDemoSubscription } = useSubscription();
    const navigate = useNavigate();
    const [showAuthModal, setShowAuthModal] = useState(false);

    const handleGetStarted = (e) => {
        e.preventDefault();
        
        console.log('CustomBanner - handleGetStarted - isAuthenticated:', isAuthenticated);
        console.log('CustomBanner - handleGetStarted - hasActiveSubscription:', hasActiveSubscription);
        console.log('CustomBanner - handleGetStarted - isDemoSubscription:', isDemoSubscription);
        
        if (!isAuthenticated) {
            console.log('CustomBanner - Opening AuthModal for demo');
            setShowAuthModal(true);
        } else if (hasActiveSubscription && !isDemoSubscription) {
            toast.info('You already have a premium subscription!');
            navigate('/dashboard');
        } else if (isDemoSubscription) {
            toast.info('You already have demo access!');
            navigate('/dashboard');
        } else {
            navigate('/demo-confirmation');
        }
    };

    return (
        <section className={`custom-banner-section ${props.fClass || ''}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="custom-banner-wrapper">
                            <div className="banner-content">
                                <div className="banner-text-section">
                                    <h2 className="banner-title">
                                        {t('customBanner.startLearningArabic')}<br />
                                        {t('customBanner.onlineToday')}
                                    </h2>
                                </div>
                                <div className="banner-button-section">
                                    <a href="#" onClick={handleGetStarted} className="banner-cta-button">
                                        {t('customBanner.getStarted')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Authentication Modal */}
            <AuthModal
                isOpen={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                title="Account Required"
                message="To access your free demo you need to set up your account first"
                type="demo"
                redirectState={{ action: 'demo' }}
            />
        </section>
    )
}

export default CustomBanner